import React from 'react';
import PrivateRoute from '../hoc/PrivateRoute/PrivateRoute';
import PrototipoProvider from './PrototipoProvider';
import HomePage from './pages/HomePage';
import PesquisaProcessosPage from './pages/PesquisaProcessosPage';
import ControleProcessosPage from './pages/ControleProcessosPage';

/**
 * Rotas do protótipo, no mesmo padrão de `src/routes/Routes<Modulo>.jsx`.
 *
 * COMO MONTAR — em `src/routes/Routes.jsx`:
 *
 *   import { RoutesPrototipo } from '../prototipo/RoutesPrototipo';
 *   ...
 *   <BrowserRouter>
 *     <Switch>
 *       <Route path="/login" component={LoginPage} />
 *       <RoutesPrototipo />            {'<--'} AQUI, FORA do <LayoutNavigation>
 *       <LogoutTimer>
 *         <LayoutNavigation>
 *           ...
 *
 * O posicionamento importa: **fora** do `LayoutNavigation`. O novo layout
 * substitui o menu lateral de 96px por uma barra superior, então montar dentro
 * do `LayoutNavigation` empilharia as duas navegações e deslocaria o conteúdo
 * em 96px. Se a decisão for conviver com o menu lateral atual durante a
 * transição, mova para dentro e remova o `<Topbar>` do `AppShell`.
 *
 * Usa `PrivateRoute` para reaproveitar a validação de sessão do login real.
 * Sem `roles`/`tipoUsuario`, qualquer usuário autenticado acessa — ver
 * `allowRouteAccess` em `PrivateRoute.jsx` (roles vazio libera o acesso).
 */
export function RoutesPrototipo() {
  return (
    <PrototipoProvider>
      <PrivateRoute path="/prototipo/home" component={HomePage} />
      <PrivateRoute path="/prototipo/pesquisa" component={PesquisaProcessosPage} />
      <PrivateRoute path="/prototipo/processos" component={ControleProcessosPage} />
    </PrototipoProvider>
  );
}

export default RoutesPrototipo;
